import { render, staticRenderFns } from "./OAuthClerkForm.vue?vue&type=template&id=6bcef7f4&"
import script from "./OAuthClerkForm.vue?vue&type=script&lang=js&"
export * from "./OAuthClerkForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports